'use client';

import Image from 'next/image';

export default function CheapSection() {
  const cards = [
    {
      emoji: '🤖',
      // icon: '/images/icon_airoute.png',
      title: 'AI 경로 최적화',
      desc: 'AI가 운행 경로, 방문 시각, 화물 적재량을 최적화해 운송 효율을 최대화합니다.',
    },
    {
      emoji: '⚙️',
      // icon: '/images/icon_hightechtool.png',
      title: '최신 기술 장비',
      desc: '최신 기술 장비들로 기사 한 명이 운반의 모든 것을 처리합니다. 인건비 거품을 없앴습니다.',
    },
    {
      emoji: '🎯',
      // icon: '/images/icon_target.png',
      title: '맞춤 서비스',
      desc: '물품 정보, 일정, 추가 옵션을 세밀하게 계산해 필요한 만큼만 지불하는 맞춤형 가격을 제공합니다.',
    },
  ];

  return (
    <section
      className="relative overflow-hidden"
      style={{
        background: '#1a3a5c',
        backgroundImage:
          'linear-gradient(rgba(255,255,255,.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.03) 1px, transparent 1px)',
        backgroundSize: '48px 48px',
      }}
    >
      {/* Ghost word */}
      <span
        className="absolute pointer-events-none select-none font-black leading-none"
        style={{
          fontSize: 'clamp(5rem, 12vw, 10rem)',
          letterSpacing: '-0.02em',
          opacity: 0.055,
          color: '#fff',
          left: '-1%',
          bottom: '5%',
          whiteSpace: 'nowrap',
        }}
      >
        PRICE
      </span>

      <div className="relative z-10 max-w-[1000px] mx-auto px-6 py-20 sm:py-32">
        {/* Eyebrow */}
        <p
          className="inline-flex items-center gap-2.5 text-s font-extrabold tracking-[0.22em] uppercase mb-3"
          style={{ color: '#f5a060' }}
        >
          저렴한 배송, 당나귀배송
        </p>

        {/* Headline */}
        <h2
          className="font-black leading-[1.15] mb-2.5 text-white"
          style={{ fontSize: 'clamp(2rem, 4vw, 2.5rem)' }}
        >
          기술력과 노하우가 만든<br className="sm:hidden" /> 완전히 차별화된 가격
        </h2>

        {/* Description */}
        <p className="text-base font-medium leading-[1.7] mb-12 max-w-[520px]" style={{ color: 'rgba(255,255,255,.7)' }}>
          비용 거품을 제거한 합리적인 가격, 그 뒤엔 당나귀만의 기술이 있습니다.
        </p>

        {/* Tech cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className="rounded-[20px] px-7 py-8 hover:-translate-y-1 transition-all duration-200"
              style={{
                background: 'rgba(255,255,255,.07)',
                border: '1px solid rgba(255,255,255,.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,.11)';
                e.currentTarget.style.borderColor = 'rgba(232,121,60,.5)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,.07)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,.1)';
              }}
            >
              <span className="block text-4xl mb-4">{card.emoji}</span>
              {/* <Image src={card.icon} alt={card.title} width={76} height={76} className="object-contain mb-4" /> */}
              <h3 className="text-base font-extrabold text-white mb-2.5">{card.title}</h3>
              <p className="text-sm leading-[1.65]" style={{ color: 'rgba(255,255,255,.6)' }}>
                {card.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Highlight banner */}
        <div
          className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-6 rounded-2xl px-7 py-5"
          style={{
            background: 'rgba(232,121,60,.15)',
            border: '1px solid rgba(232,121,60,.3)',
          }}
        >
          <span className="text-5xl font-black shrink-0" style={{ color: '#E8723A' }}>
             10,000원부터
          </span>
          <div>
            <p className="font-bold text-white text-base mb-1">똑똑한 소비자의 합리적인 선택</p>
            <p className="text-sm" style={{ color: 'rgba(255,255,255,.65)' }}>
              스탠딩 골프백 10,000원, 전자레인지 12,000원, 슈퍼싱글매트리스 19,000원, 47인치 TV 18,000원 <br/><span className="text-xs">(*3km이내, 문앞배송 기준)</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
